export default function ContractEA({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker EA方案</div>
      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          Becker EA 輔考方案購買須知與同意事項（請務必詳閱）
        </h5>
        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            
<section>
  <h4>一、訂購程序、審閱期與契約成立</h4>
  <p><strong>1. 訂購程序</strong></p>
  <ol>
    <li>購買方案者，須填妥本訂購單資料表，完整審閱本購買須知與相關規定後，完成付費，方符合訂購程序。</li>
    <li>繳費前，請先確認購買產品內容、方案項目、費用及相關使用限制。</li>
  </ol>
  <p><strong>2. 審閱期與購買者資格</strong></p>
  <ol>
    <li>購買前請確認已完整審閱本購買須知與相關規定，審閱期已達五日。</li>
    <li>購買方案者保證為完全行為能力人，或為已得法定代理人同意之限制行為能力人。</li>
  </ol>
  <p><strong>3. 契約成立與電子簽名</strong></p>
  <ol>
    <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容。</li>
    <li>購買者同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。</li>
    <li>購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
  </ol>
</section>

<section>
  <h4>二、退費、七日猶豫期與數位內容提供</h4>
  <p><strong>1. 數位內容與七日解除權排除</strong></p>
  <ol>
    <li>本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條可排除消費者保護法第 19 條七日解除權之合理例外情事者。</li>
    <li>本人知悉並同意，本商品屬非以有形媒介提供之數位內容及／或一經提供即為完成之線上服務；一經帳號開通、登入、教材領取或課程內容提供，即排除消保法第 19 條七日解除權之適用。</li>
  </ol>
  <p><strong>2. 七日猶豫期內退費</strong></p>
  <ol>
    <li>若商品未經領取、未開始參加課程、且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費。</li>
    <li>若已取得諮詢者，退費時需扣除每階段新台幣 1,000 元諮詢費。</li>
  </ol>
  <p><strong>3. 帳號開通、教材領取或登入後之限制</strong></p>
  <ol>
    <li>除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
    <li>學員之個人教材軟體帳號經首次登入後，教材恕不退費，亦不得要求暫停效期。</li>
  </ol>
</section>

<section>
  <h4>三、教材、軟體授權與帳號使用規範</h4>
  <p><strong>1. 授權範圍與使用效期</strong></p>
  <ol>
    <li>Becker EA Exam Review 教材為美國原版教材與軟體，授權限購買者本人使用，嚴禁轉售、轉贈、共用。</li>
    <li>違反前項規定者，將負擔購買總價十倍之懲罰性違約金與其他損害賠償。</li>
    <li>軟體授權使用期限為：自購買日起算 12 個月後自動終止。</li>
  </ol>
  <p><strong>2. 帳號與登入管理</strong></p>
  <ol>
    <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知。</li>
    <li>利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。</li>
    <li>因非可歸責於 Becker Taiwan（捷進）之事由導致登入密碼外洩時，學員應儘速通知；Becker Taiwan（捷進）除提供必要協助外，不負任何法律上責任。</li>
    <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education 與 Becker Taiwan（捷進）將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址（IP address）等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況，Becker Taiwan（捷進）有權中止該帳號之軟體權限。</li>
  </ol>
  <p><strong>3. E-mail 通訊義務</strong></p>
  <ol>
    <li>學員所提供之 E-mail 必須有效期達一年以上。</li>
    <li>所有帳號通知、課程資訊、系統更新皆以該信箱為唯一正式聯絡方式。若因未定期查收郵件而錯過通知，學員應自負相關責任。</li>
  </ol>
</section>

<section>
  <h4>四、教材內容、版本管理與紙本書籍</h4>
  <p><strong>1. 電子書與紙本教材</strong></p>
  <ol>
    <li>自 2025 年起，Becker EA 方案皆內含電子書教材。</li>
    <li>是否含紙本教科書依各方案公告為準：部分方案內含紙本書籍，部分方案則不含，如無內含亦可選擇另行加購。</li>
    <li>紙本教科書之加購費用將依 Becker 美國總部之定價加上國際運費計算。</li>
  </ol>
  <p><strong>2. 新版教科書加購</strong></p>
  <ol>
    <li>若學員考試未通過，於帳號效期內可提出「三個月內未及格成績單」或「考場預約證明」，申請購買新版教科書。</li>
    <li>前項新版教科書仍需依照最新版本價格重新加購。</li>
  </ol>
  <p><strong>3. 紙本書籍預購與運送</strong></p>
  <ol>
    <li>紙本書籍採預購及國際運送機制，寄達台灣時間依海關通關及物流狀況安排，恕無法指定收書時間。</li>
    <li>若遇書籍取用完畢，需等待國際郵務寄達台灣，無法指定取書時間。</li>
  </ol>
  <p><strong>4. 教材供應與變更聲明</strong></p>
  <ol>
    <li>原廠 Becker Professional Education 若有停產或規格調整，Becker Taiwan 保有調整或停止供貨之權利，恕不另行賠償。</li>
    <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，亦保留任何因賣方代理原廠更改貨品規格而更改之權利，並對此不負擔責任。</li>
  </ol>
</section>

<section>
  <h4>五、使用設備與連線需求</h4>
  <p><strong>1. 基本設備與系統需求</strong></p>
  <ol>
    <li>使用本服務應具備下列軟硬體設備基本規格及要求：<br />Windows PC/NB：Windows 7 以上<br />Apple PC/NB：macOS 10 以上<br />Apple 行動裝置：iOS 13.0 以上<br />Android 行動裝置：Android 8.0 以上<br />行動裝置限定使用 APP 版觀看課程<br />連線需求：寬頻網路下載速度 20Mbps 以上</li>
  </ol>
  <p><strong>2. 網路使用建議</strong></p>
  <ol>
    <li>不建議使用無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
    <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
  </ol>
</section>

<section>
  <h4>六、中文線上課程與加值服務</h4>
  <p><strong>1. 適用範圍</strong></p>
  <ol>
    <li>各 EA 方案所含中文加值服務（線上課程、顧問諮詢、講師解題等）依實際公告為準，購買前請確認方案內容。</li>
    <li>各方案可能包含之中文課程、線上發問系統等在地中文加值服務，其使用有效期限與軟體效期一致。</li>
    <li>學員之軟體使用效期結束，或學員通過全科考試時，若未使用完畢加值服務之各類型課程時數，剩餘時數等同失效，學員不得異議。</li>
  </ol>
  <p><strong>2. 中文課程使用原則（適用含中文課程之方案）</strong></p>
  <ol>
    <li>中文課程為線上形式，實際三科總時數依每期官網公告之課表為準。</li>
    <li>中文課程研發目的在幫助考生加速通過考試，故學員使用或參加中文課程時間點為通過考試之前，並須於軟體效期內完成。</li>
    <li>若曾參加課程但考試未通過，得於課程開課期間，檢附未通過成績單，申請該科中文課程重上一次。</li>
    <li>直播、線上隨選隨看及雲端課程中，不得針對課程內容進行任何錄音、錄影等側錄行為。</li>
  </ol>
  <p><strong>3. 未含中文課程方案之限制</strong></p>
  <ol>
    <li>購買「無」中文課程產品或自修方案者，不得要求索取中文加值服務或中文課程之各項研習講義、文件資料。</li>
    <li>未包含中文講師解題服務者，不得以任何形式要求提供中文解題協助。</li>
  </ol>
  <p><strong>4. 中文線上課程加購與限制</strong></p>
  <ol>
    <li>學員購買方案含中文課程者，當發生免費時數額度用罄情況，於軟體有效效期內，得以單堂三小時為單位加購使用額度。</li>
    <li>曾購買全科方案者，單堂加購金額為新台幣 1,500 元整。</li>
    <li>曾購買非全科方案者，單堂加購金額為新台幣 2,500 元整。</li>
    <li>加購者不得使用中文講師線上解題服務。</li>
    <li>加購課程需依 Becker Taiwan 中文課程上架時間表規劃安排，並須提前預約。</li>
  </ol>
  <p><strong>5. 中文講師解題服務</strong></p>
  <ol>
    <li>中文講師解題服務僅限含此項服務之方案使用。</li>
    <li>次數與使用方式依每期公告為準。</li>
    <li>未包含此項服務者，不得以任何形式要求提供中文解題協助。</li>
  </ol>
  <p><strong>6. 上課形式與服務調配規則</strong></p>
  <ol>
    <li>方案內含之中文課程為線上學習形式。</li>
    <li>Becker Taiwan（捷進）保有各上課形式之開課時間、雲端空間開放時間、雲端影片上架時間之最終決定權，學員不得異議。</li>
    <li>Becker Taiwan（捷進）保有中文雲端課程於雲端提供時間點、提供內容範圍之決定權，依各期課程影片上架公告為準，學員不得異議。</li>
    <li>Becker Taiwan（捷進）保有各項諮詢服務、雲端流量資源之分配決定權，學員若欲使用相關服務，須提前來電或來訊預約，以確認相關服務狀態與起迄時間。</li>
    <li>以上中文課程項目、加值服務與相關內容，Becker Taiwan（捷進）保留變更、終止、修改及解釋之權利。</li>
  </ol>
  <p><strong>7. 第三方教學影音平台聲明</strong></p>
  <ol>
    <li>中文雲端課程係透過第三方教學影音平台提供。</li>
    <li>若因該第三方平台之系統維護、服務中斷、連線異常、平台功能調整或其他非可歸責於 Becker Taiwan（捷進）之事由，致學員暫時無法觀看或使用課程，Becker Taiwan（捷進）將提供必要協助並協調恢復服務，惟不負因此所生之損害賠償責任。</li>
  </ol>
</section>

<section>
  <h4>七、考試顧問諮詢服務</h4>
  <p><strong>1. 使用資格與服務內容</strong></p>
  <ol>
    <li>考試顧問諮詢服務僅限購買「含顧問諮詢服務」之方案使用。</li>
    <li>服務內容包含考程規劃、報名與應考流程說明與諮詢。</li>
    <li>未包含此項服務者，不得使用任何形式（現場、LINE、電話、電郵等）詢問報考流程，如有需求可待顧問服務上線後以單次加購方式取得。</li>
  </ol>
  <p><strong>2. 預約與服務調整</strong></p>
  <ol>
    <li>Becker Taiwan（捷進）保有各項線上／電話／通訊軟體諮詢服務、雲端流量分配及教室座位分配之決定權。</li>
    <li>學員欲使用上開諮詢服務或加值服務，均須提前來電、來信或來訊預約，以確認服務團隊、辦公室與教室空間之服務狀態與起迄時間。</li>
    <li>配合中華民國各級政府單位規定，遇天災、疫情、緊急事件或其他不可抗力因素，致 Becker Taiwan（捷進）提供之線上／電話／通訊軟體諮詢服務受到影響時，Becker Taiwan（捷進）將依實際情形調整服務提供方式、服務時間或暫停受影響之服務。</li>
  </ol>
</section>

<section>
  <h4>八、持續展延（Unlimited Access）條款</h4>
  <ol>
    <li>購買包含持續展延資格之方案者，於效期內得提供考場預約證明，申請展延單科 4 個月，並以原到期日翌日為起算日。</li>
    <li>前項展延須於期限前提出申請。</li>
    <li>軟體效期若獲免費展延，延長之效期起算日為原有到期日之隔天，不得提早或延後起算。</li>
  </ol>
</section>

<section>
  <h4>九、報考資格與官方審查聲明</h4>
  <ol>
    <li>Becker Taiwan 所提供之報考建議或流程說明，僅供參考。</li>
    <li>購買者之報考資格應以考試指定之認證機構以及報名審查官方機構出具之審查結果為準。</li>
    <li>考試資格依美國政府官方核發單位或審查機構最終裁定為準。</li>
  </ol>
</section>

<section>
  <h4>十、個人資料保護與隱私權聲明</h4>
  <p><strong>1. 蒐集、處理及利用目的</strong></p>
  <ol>
    <li>Becker Taiwan（捷進）基於本訂購單履約之目的，蒐集、處理並利用您的個人資料。本公司將依個人資料保護法第 8 條第 1 項之要求，向您告知以下事項。</li>
    <li>蒐集目的：依照 101 年 10 月 1 日修正之個人資料保護法之特定目的及個人資料之類別，040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務。</li>
  </ol>
  <p><strong>2. 個人資料類別</strong></p>
  <ol>
    <li>C001 電子郵件、中文姓名、英文拼音全名、電話號碼。</li>
    <li>C002 金融機構帳戶號碼與姓名。</li>
    <li>C003 身分證字號。</li>
    <li>C036 是否曾訂購本公司產品、得知本公司之管道。</li>
    <li>C038 在職身分。</li>
    <li>C051 所屬或畢業學校與科系。</li>
  </ol>
  <p><strong>3. 個人資料利用期間、地區、對象及方法</strong></p>
  <ol>
    <li>本公司會於契約履行、學員服務、帳務處理、法令保存期間及爭議處理所必要期間內利用您的個人資料。</li>
    <li>利用地區包含中華民國境內及 Becker 原廠帳號開通、服務提供所必要之境外地區。</li>
    <li>本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。</li>
    <li>本公司並將分析您提供之類別 C036、C038、C051 等資訊，以增進本公司之服務。</li>
    <li>除為履行本契約、開通 Becker 原廠帳號、寄送商品、金流／物流／系統服務所必要，或依法令要求外，在未經您的同意下，我們不會任意將您的個人資料提供給第三人或作不當利用。</li>
  </ol>
  <p><strong>4. 個資不完整之影響與權利行使</strong></p>
  <ol>
    <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
    <li>您得行使個資法第 3 條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。</li>
  </ol>
</section>

<section>
  <h4>十一、付費購買與匯款資訊</h4>
  <p><strong>1. 在台購買</strong></p>
  <table className="table table-bordered mt-2 mb-3">
    <tbody>
      <tr><th style={{ width: "30%", textAlign: "left", background: "#f5f5f5" }}>收款人戶名</th><td>捷進顧問有限公司</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>受款銀行</th><td>華南商業銀行信維分行（代碼：008）</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>收款人帳號</th><td>149-10-010062-0</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>匯款金額</th><td>以新台幣付費，依各方案價格計算；若需快遞書籍，請加上運費。</td></tr>
    </tbody>
  </table>
  <p>台灣境內快遞計費方式：便利袋快遞費每箱新台幣 100 元。因快遞公司重量限制，寄送 1–2 本為一箱，寄送 3–4 本須為兩箱。</p>

  <p><strong>2. 海外購買</strong></p>
  <table className="table table-bordered mt-2 mb-3">
    <tbody>
      <tr><th style={{ width: "30%", textAlign: "left", background: "#f5f5f5" }}>Recipient Name</th><td>Direct Line Consulting Co.</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>Account Number</th><td>149-10-010062-0</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>Bank</th><td>Hua Nan Commercial Bank Ltd.</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>Branch</th><td>Hsin-Wei Branch</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>SWIFT Code（Bank ID）</th><td>HNBKTWTP149</td></tr>
      <tr><th style={{ textAlign: "left", background: "#f5f5f5" }}>Bank Address</th><td>2F, No. 6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan</td></tr>
    </tbody>
  </table>
  <p>匯款金額：以新台幣付費，依各方案價格計算；若需快遞書籍，請加上運費，並請採全額到匯。相關中轉行手續費計算方式請向您的支付銀行確認；若無法估算，請直接另附新台幣 200 元之中轉行手續費。</p>
  <p>快遞計費方式：由美國 Becker 直接發貨，單次寄送郵資為新台幣 1,200 元。</p>
</section>

<section>
  <h4>十二、契約終止</h4>
  <ol>
    <li>學員如有違反強制禁止規定或公序良俗之行為，或違反本契約經限期改正仍未改正者，Becker Taiwan（捷進）得終止本契約，學員不得異議。</li>
    <li>學員若違反本契約條款或社會公序良俗，或限期改善未果，Becker Taiwan 得終止契約且不退費。</li>
    <li>如學員自行或因可歸責於己之事由終止契約者，除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
  </ol>
</section>

          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
